import { render, staticRenderFns } from "./CategoryActions.vue?vue&type=template&id=25c4314a&scoped=true&"
import script from "./CategoryActions.vue?vue&type=script&lang=ts&"
export * from "./CategoryActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4314a",
  null
  
)

export default component.exports